module.exports = __webpack_public_path__ + "img/744.d82cb6d8.jpg";